import React from 'react';
import ReactDOM from 'react-dom/client';

// Instrument Sans : la famille unique de la charte V3, chargee localement. Inter
// reste le temps que tous les ecrans y passent ; les deux ne coexistent sur aucun.
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/inter';

import App from './app/App';

import './index.scss';
import './tailwind.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <>
        <App />
    </>
);
